import { render } from "./ItemToggle.vue?vue&type=template&id=71be1163"
import script from "./ItemToggle.vue?vue&type=script&lang=js"
export * from "./ItemToggle.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__